import abcColoringBookThumb from '../assets/abc-coloring-book-thumb.png';
import happyTreeValleyThumb from '../assets/happy-tree-valley-thumb.png';
import mangoTreeThumb from '../assets/the-mango-tree-thumb.png';

function amazonSearchUrl(query) {
  return `https://www.amazon.com/s?k=${encodeURIComponent(query)}`;
}

export const BUY_LABEL = 'Buy now';
export const COMING_SOON_LABEL = 'Coming soon';

export const STATUS = {
  BUY_NOW: 'buy_now',
  COMING_SOON: 'coming_soon',
};

/** Books pillar display order (subset of LIBRARY). */
export const PILLAR_BOOK_IDS = [
  'abc-jungle-adventure',
  'happy-tree-valley',
  'a-new-friend',
  'giving-tree',
  'color-of-kindness',
];

export const LIBRARY = [
  {
    id: 'abc-coloring',
    title: 'Libby the Lion & Friends ABC Coloring Book Adventure',
    tagline:
      'Color the alphabet with Libby and friends — a bright ABC adventure you can order today as her world keeps growing with new stories, friends, and fun.',
    cover: abcColoringBookThumb,
    coverAlt: 'Cover: Libby the Lion & Friends ABC Coloring Book Adventure',
    status: STATUS.BUY_NOW,
    buyUrl: 'https://buy.stripe.com/test_00wcN4gJ7b9J0zN7aseIw02',
  },
  {
    id: 'happy-tree-valley',
    title: 'The Adventures of Libby the Lion & Friends: Happy Tree Valley',
    tagline:
      'Walk through a magical valley of smiling trees and cheerful friends — a colorful story about kindness, wonder, and adventure with Libby and her crew.',
    cover: happyTreeValleyThumb,
    coverAlt: 'Cover: The Adventures of Libby the Lion & Friends: Happy Tree Valley',
    status: STATUS.BUY_NOW,
    buyUrl: 'https://buy.stripe.com/test_9B628q3Wl4Ll3LZ7aseIw01',
  },
  {
    id: 'mango-tree',
    title: 'The Adventures of Libby the Lion & Friends: The Mango Tree',
    tagline:
      'Join Libby as she picks ripe mangoes under the sun — a sweet tropical tale about sharing, friendship, and the joy of a sunny day adventure.',
    cover: mangoTreeThumb,
    coverAlt: 'Cover: The Adventures of Libby the Lion & Friends: The Mango Tree',
    status: STATUS.BUY_NOW,
    buyUrl: 'https://buy.stripe.com/test_3cI28qcsR1z9fuHeCUeIw00',
  },
  {
    id: 'abc-jungle-adventure',
    title: 'The Adventures of Libby the Lion & Friends: ABC Jungle Adventure',
    status: STATUS.COMING_SOON,
  },
  {
    id: 'a-new-friend',
    title: 'The Adventures of Libby the Lion & Friends: A New Friend',
    status: STATUS.COMING_SOON,
  },
  {
    id: 'giving-tree',
    title: 'The Adventures of Libby the Lion & Friends: The Giving Tree',
    status: STATUS.COMING_SOON,
  }
];

export const LIBRARY_BY_ID = Object.fromEntries(LIBRARY.map(book => [book.id, book]));

export function getBuyableBooks() {
  return LIBRARY.filter(book => book.status === STATUS.BUY_NOW);
}

export function getComingSoonBooks() {
  return LIBRARY.filter(book => book.status === STATUS.COMING_SOON);
}

export function getBooksForPillar() {
  return PILLAR_BOOK_IDS.map(id => LIBRARY_BY_ID[id]).filter(Boolean);
}

/** Primary hero / default buy link (first buyable book). */
export const PRIMARY_BUY_URL = getBuyableBooks()[0]?.buyUrl;
